import { Heading, Text } from '@ui'
import React, { FC, ReactNode } from 'react'

interface Props {
  emoji?: string
  title: string
  description?: string
  bottomAction?: ReactNode
}

const EmptyList: FC<Props> = ({ emoji, title, description, bottomAction }) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 px-4 py-8 text-center">
      <span className="mb-1 grid size-14 place-items-center rounded-full bg-surface-2 text-[28px]">
        {emoji || '🙄'}
      </span>
      <Heading level={4}>{title}</Heading>
      {description && (
        <Text variant="body-s" tone="fg-2" className="max-w-[36ch]">
          {description}
        </Text>
      )}
      {bottomAction && <div className="mt-3">{bottomAction}</div>}
    </div>
  )
}

export default EmptyList
